import { FC } from "react";

type ArrowDownIconProps = {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const ArrowDownIcon: FC<ArrowDownIconProps> = ({
  width = 16,
  height = 16,
  fill = "rgba(153, 153, 153, 1)",
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      fill="none"
    >
      <path
        fill={fill}
        d="M11.4681 15.5336L5.99609 10.0606L7.05686 9L11.9985 13.9426L16.9401 9L18.0008 10.0606L12.5288 15.5336C12.3882 15.6743 12.1974 15.7533 11.9985 15.7533C11.7995 15.7533 11.6087 15.6743 11.4681 15.5336Z"
      />
    </svg>
  );
};
